import React, { useState, useEffect, useRef, useContext } from 'react';
import {FormLayout, InlineError} from '@shopify/polaris';
import { FormContext } from '@thinkwell/react.common'
import { TextField } from '@thinkwell/react.polaris'

export default function PasswordForm(props) {
  const form = useContext(FormContext)

  const names = props.names || {}
  names.password = names.password || 'password'
  names.password_confirmation = names.password_confirmation || 'password_confirmation'

  const validate = () => {
    const pwd1 = form.field(names.password)
    const pwd2 = form.field(names.password_confirmation)
    const errors = []
    if(!pwd1 || pwd1.length < 6) {
      errors.push("Password must be at least 6 characters long")
    }

    if(props.withConfirmation && pwd1 !== pwd2) {
      errors.push("Passwords don't match")
    }

    return errors
  }

  form.register('password_form', validate)

  return (
    <div>
      <FormLayout>
        <FormLayout.Group>
          <TextField
            label="Password"
            type="password"
            name={names.password}
          />
          { props.withConfirmation ? <TextField
              label="Repeat Password"
              type="password"
              name={names.password_confirmation}
            /> : null }
        </FormLayout.Group>
      </FormLayout>
    </div>
  );
}
